import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { AppConfigurator } from '../../app.configurator';



@Component({
    selector: 'app-appearance-settings',
    imports: [
        CommonModule,
        FormsModule,
        AppConfigurator
    ],
    template: `
    <div>
    <app-configurator></app-configurator>
    </div>
    `,
    standalone: true,
})
export class AppearanceSettingsComponent {
  @Input() minimal: boolean = false;

  constructor(
  ) {}

}
